<template>
    <div class="views-content--articles">
        <banner-generic :data="data.hero"></banner-generic>

        <section class="article-filter space--md">
            <div class="container">
                <div class="row">
                        <div class="col-xs-12">
                            <div v-if="filterKeys.categories.length>0" class="filter-wrapper filter-wrapper--text-only">

                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--primary" @scroll="slideOnScroll('filter-wrapper--primary')">
                                        <div class="items">
                                            <a 
                                                href="#" 
                                                class="category"
                                                :class="[
                                                    selectedFilter.category.includes(category.urlsegment) ? 'selected' : null
                                                ]" 
                                                v-for="(category, index) in filterKeys.categories" 
                                                :key="index"  
                                                @click.prevent="filter(category.filterid, 'category', category.urlsegment)" 
                                                :data-id="category.filterid"
                                            >
                                                {{category.title}}
                                            </a>
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <button id="filter-wrapper--prev--primary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--primary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--primary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>
                            <div class="filter-wrapper filter-wrapper--text-icon">
                                <div class="filter-wrapper--hide-scroll">
                                    <div class="inner" id="filter-wrapper--secondary" @scroll="slideOnScroll('filter-wrapper--secondary')">
                                        <div class="items">
                                            <a href="#" @click.prevent="filter('reset-this-filter', 'tag', null)"
                                                :class="[
                                                    selectedFilter.tag.length<=0 ? 'selected' : null
                                                ]" 
                                            >All</a>
                                            <a href="#" v-for="(tag, index) in filterKeys.tags" 
                                                :class="[
                                                    selectedFilter.tag.includes(tag.urlsegment) ? 'selected' : null
                                                ]" 
                                                :key="index" @click.prevent="filter(tag.filterid, 'tag', tag.urlsegment)" :data-id="tag.filterid"
                                            >
                                                {{tag.title}}
                                            </a>
                                            <div class="spacer">&nbsp;</div>
                                        </div>
                                    </div>
                                </div>
                                
                                <button id="filter-wrapper--prev--secondary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>

                                <button id="filter-wrapper--next--secondary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary')">
                                    <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                    </svg>
                                </button>
                            </div>

                            <div class="filter-wrapper--separator"></div>
                        
                        </div>
                </div>
            </div>
        </section>

        <section class="casestudies">
            <div class="padding--md">
                <div class="container">                    
                    <masonry-wall :items="filteredItems" :ssr-columns="1" :gap="30">
                        <template #default="{ item, index }">
                            <card 
                                :data="item" 
                                :theme="theme" 
                                :class="index<itemsToShow ? '' : 'hidden'"
                            ></card>
                        </template>
                    </masonry-wall>
                </div>
            </div>
            <div class="space-bottom--xl">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="text-center">
                                <div v-if="itemsToShow < filteredItems.length || filteredItems.length > itemsToShow">
                                    <button class="button button--solid-black" @click="itemsToShow += 12">Show More</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

         <!-- elements -->
        <div v-for="element in data.elements" :key="element.id">
            <component :is="element.vueName" :data="element" />
        </div>
        
    </div>
</template>

<script>
    import { BannerGeneric, Card } from "../components";
    import { ElementAccordion, ElementBackgroundImage, ElementContent, ElementCTA, ElementColours, ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage, ElementForm} from "../components";
    import axios from 'axios';
    export default {
        name: "v-articles",
        components: {
            BannerGeneric,
            Card,
            ElementBackgroundImage,
            ElementAccordion,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage,
            ElementForm
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                theme: 'simple', // theme is passed down to the colorcard component for this page only.
                itemsToShow: 12,
                totalItems: 0,
                items: [],
                filteredItems: [],
                selectedFilter: {
                    category: [],
                    tag: []
                },
                filterKeys: {
                    categories: [],
                    tags: []
                },
                itemsSample: [
                    {
                        title: 'First',
                        description: 'The first item.',
                    },
                    {
                        title: 'Second',
                        description: 'The second item.',
                    },
                ],
                intervalID: 0
            }
        },
        methods: {
            filter(key, type, value){
                this.itemsToShow = 12;

                // put selected categoru and tags in variable
                // this also can be used to managed selected item class
                if (this.selectedFilter[type].includes(value)) {
                    this.selectedFilter[type].splice(this.selectedFilter[type].indexOf(value),1);
                } else {
                    this.selectedFilter[type].push(value);
                }

                if(key==='reset-this-filter'){
                    this.selectedFilter[type] = [];
                }

                let filteredList = this.filterbyTagsAndCategories(this.items, this.selectedFilter);
                this.filteredItems = filteredList;
            },
            slidePrev(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3 * (-1), 0);
            },
            slideNext(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3, 0);
            },
            slideOnScroll(id) {
                const slideBuffer = 10;
                const elem = typeof id === 'string' ? document.getElementById(id) : id;
                const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

                elem.parentNode.parentNode.classList.add('no-scroll');
                if(isScrolling){
                    elem.parentNode.parentNode.classList.remove('no-scroll');
                }

                if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
                    elem.parentNode.parentNode.classList.add('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.add('is-min');
                } else {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                }
            },
            detectButtonVisibility() {
                let status = true;

                const slideItems = [
                    document.getElementById('filter-wrapper--primary'),
                    document.getElementById('filter-wrapper--secondary')
                ];
                const slideButtons = [
                    document.getElementById('filter-wrapper--next--primary'),
                    document.getElementById('filter-wrapper--next--secondary')
                ];

                slideItems.forEach((elem, index) => {
                    if(elem){
                        if(elem.querySelector('.items').offsetWidth<=0) status = false;
                        if(elem.querySelector('.items').offsetWidth<=elem.offsetWidth){
                            slideButtons[index].classList.add('hidden');
                        }else{
                            slideButtons[index].classList.remove('hidden');
                        }

                        this.slideOnScroll(elem);
                    }
                });

                return status;
            }
        },
        mounted() {
            const app = this;

            this.items = this.convertItemsObjToArray( this.data.articles )
            this.filteredItems = this.convertItemsObjToArray( this.data.articles )
            this.totalItems = this.items.length

            this.filterKeys = this.getFilteredCatAndTagList(this.items, this.data.categories, this.data.tags);

            this.intervalID = setInterval(() => {
                let status = app.detectButtonVisibility();
                if(status) clearInterval(this.intervalID );
            }, 100);

            window.addEventListener('resize', () => {
                clearTimeout(this.intervalID);
                this.intervalID = setTimeout(() => {
                    app.detectButtonVisibility();
                }, 250);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    .articles--featured {
        margin: 2rem 0;

        @media #{$md} {
            margin: 8rem 0;
        }

        .container-mobile-width {
            min-width: 62em;

            @media #{$md} {
                min-width: inherit;
            }
        }
    }

</style>
